import { Link } from '@doveit/bricks';
import React from 'react';
import { URLObject } from '../../utils/links';
import { SeoLink } from '../seo-links/SeoLinks';
import * as styles from './SeoLinksList.style';

export interface SeoLinksListProps {
  links: SeoLink[],
  onLinkClick?: (to: URLObject) => void,
}

const SeoLinksList: React.FC<SeoLinksListProps> = ({
  links,
  onLinkClick,
}) => {
  const internalOnLinkClick = React.useCallback((to: URLObject) => () => {
    onLinkClick(to);
  }, [onLinkClick]);
  return (
    <ul css={styles.base}>
      {links.map((link) => (
        <li key={link.title}>
          <Link
            href={link.to.as}
            onClick={onLinkClick && internalOnLinkClick(link.to)}
            css={styles.link}
            data-ref="seo-links-list-anchor"
          >
            {link.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SeoLinksList;
